module.exports = __webpack_public_path__ + "static/media/united-kingdom.65fc7d56.svg";